import { render, staticRenderFns } from "./OrdenField.vue?vue&type=template&id=576c575e&scoped=true&"
import script from "./OrdenField.vue?vue&type=script&lang=js&"
export * from "./OrdenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576c575e",
  null
  
)

export default component.exports